interface StarIconsProps {
  filled: number;
  total?: number;
  size?: number;
}

export function StarIcons({ filled, total = 4, size = 9 }: StarIconsProps) {
  return (
    <>
      {Array.from({ length: total }, (_, i) => (
        <i
          key={i}
          className={`fa${i < filled ? 's' : 'r'} fa-star`}
          style={{ color: i < filled ? '#f59e0b' : '#d1d5db', fontSize: size }}
          aria-hidden="true"
        />
      ))}
    </>
  );
}
